/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorksharingService {

  private worksharingSyncNecessarySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public worksharingSyncNecessary$: Observable<boolean> = this.worksharingSyncNecessarySubject.asObservable();

  public setWorksharingSyncNecessary(value: boolean): void {
    this.worksharingSyncNecessarySubject.next(value);    
  }

  public getWorksharingSyncNecessary(): boolean {
    return this.worksharingSyncNecessarySubject.getValue();
  }

  private worksharingInProgressSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public worksharingInProgress$: Observable<boolean> = this.worksharingInProgressSubject.asObservable();

  public setWorksharingInProgress(value: boolean): void {
    this.worksharingInProgressSubject.next(value);    
  }

  public getWorksharingInProgress(): boolean {
    return this.worksharingInProgressSubject.getValue();
  }

  private defaultTypeNotFoundForDuplicateSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public defaultTypeNotFoundForDuplicate$: Observable<boolean> = this.defaultTypeNotFoundForDuplicateSubject.asObservable();

  public setDefaultTypeNotFoundForDuplicate(value: boolean): void {
    this.defaultTypeNotFoundForDuplicateSubject.next(value);    
  }

  public getDefaultTypeNotFoundForDuplicate(): boolean {
    return this.defaultTypeNotFoundForDuplicateSubject.getValue();
  }
}
